<div mat-dialog-container>
  @if (data.title) {
    <div mat-dialog-title style="display: flex; flex-direction: row;">
      <div class="dialog-header">{{ data.title }}</div>
    </div>
  }

  <div mat-dialog-content [innerHTML]="data.message"></div>

  <div mat-dialog-actions align="end">
    @if (data.cancelMessage) {
      <button matButton="outlined"
              data-qa="close-confirm-dialog-button"
              mat-dialog-close
      >
        <mat-icon svgIcon="innogy_picto_close"></mat-icon>
        {{ data.cancelMessage }}
      </button>
    }
    <button matButton="filled"
            data-qa="confirm-dialog-confirm"
            class="button-{{ data.confirmColor }}"
            [mat-dialog-close]="true">
      <mat-icon svgIcon="innogy_picto_check"></mat-icon>
      {{ data.confirmMessage }}
    </button>
  </div>
</div>

